import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('./views/account/register'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch('auth/logOut')
        } else {
          store.dispatch('authfack/logout')
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/startup/gettingstarted',
    name: 'Getting Started',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/startup/gettingstarted')
  },
  {
    path: '/projects/grid',
    name: 'My Projects',
    meta: { authRequired: true },
    component: () => import('./views/projects/projects-grid')
  },
  {
    path: '/projects/overview',
    name: 'Project Overview',
    meta: { authRequired: true },
    component: () => import('./views/projects/overview')
  },
  {
    path: '/quotes/details',
    name: 'Quote details',
    meta: { authRequired: true },
    component: () => import('./views/quotes/quote-details')
  },
  {
    path: '/team/grid',
    name: 'My Team',
    meta: { authRequired: true },
    component: () => import('./views/team/team-grid')
  },
  {
    path: '/quotes/grid',
    name: 'User Quotes',
    meta: { authRequired: true },
    component: () => import('./views/quotes/quotes-list')
  },
  {
    path: '/features/grid',
    name: 'Features',
    meta: { authRequired: true },
    component: () => import('./views/features/features-list')
  },
  {
    path: '/templates/grid',
    name: 'Templates',
    meta: { authRequired: true },
    component: () => import('./views/templates/templates')
  },
  {
    path: '/templates/create',
    name: 'Issue Report',
    meta: { authRequired: true },
    component: () => import('./views/templates/issue-reports')
  },
 
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
 
]
